export default __webpack_public_path__ + "static/media/dr-anthony.af1dc2e6.jpg";